import { BASE_URL } from "../api_const"

export const UPLOAD_BILL_URL = BASE_URL + "/bills/upload"
